module.exports = __webpack_public_path__ + "img/ERC.37d477a1.svg";